import React from 'react'
import { fireAnalyticsEvent } from '~analyticsUtils'
import Image from 'next/image'
import Link from 'next/link'
import { PartnershipItemProps } from '~types'
import styles from './PartnershipRow.module.scss'
import { useRouter } from 'next/router'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { ConditionalWrapper } from '~elements'

const PartnershipItem = ({ icon, platformName, url = '' }: PartnershipItemProps) => {
  const { asPath } = useRouter()
  const linkModule = 'logo_row'

  if (icon?.url) {
    return (
      <div className={styles['partnership-item']}>
        <ConditionalWrapper
          condition={url.length > 0}
          wrapper={children => (
            <Link
              href={url}
              target={'_blank'}
              onClick={() => {
                fireAnalyticsEvent(url, asPath, {
                  linkLocation: 'footer',
                  clickTracking: `${linkModule}:${platformName}`,
                  linkModule: linkModule
                })
              }}
            >
              {children}
            </Link>
          )}
        >
          <Image
            width={36}
            height={36}
            sizes='100vw'
            alt={platformName || ''}
            src={icon.url}
            quality={NEXT_IMAGE_QUALITY}
          />
        </ConditionalWrapper>
      </div>
    )
  } else {
    return null
  }
}

export default PartnershipItem
